import type { ComponentPropsWithoutRef } from 'react'

const ListItemDescription = ({ className = '', ...props }: ComponentPropsWithoutRef<'dd'>) => (
  <dd className={`overflow-hidden text-[13px] text-ellipsis whitespace-nowrap text-gray-700 ${className}`} {...props} />
)

export default ListItemDescription
